import {MenuItem, Typography} from '@mui/material';
import {Setting2} from 'iconsax-react';
import {WorkspaceSettingsSettingTabsTypeEnum} from 'models/settings/workspaceSettings.model';
import {useState} from 'react';
import {WorkspaceMemberSetting} from './components';
import {AppDialog} from 'components/dialogs';
import {AppTabs} from 'components/tabs';

export const WorkspaceSetting = () => {
    const [openWorkspaceSettingDialog, setOpenWorkspaceSettingDialog] = useState(false);
    const handleToggleWorkspaceSettingDialog = () => {
        setOpenWorkspaceSettingDialog(!openWorkspaceSettingDialog);
    };
    return (
        <>
            <MenuItem
                sx={{px: 1, display: 'flex', justifyContent: 'space-between'}}
                onClick={event => {
                    event.stopPropagation();
                    handleToggleWorkspaceSettingDialog();
                }}
            >
                <Typography>Workspace Settings</Typography>
                <Setting2 size={'18px'} />
            </MenuItem>
            {openWorkspaceSettingDialog && (
                <AppDialog
                    open={openWorkspaceSettingDialog}
                    onCloseDialog={handleToggleWorkspaceSettingDialog}
                    title="Workspace Settings"
                    children={
                        <>
                            <AppTabs
                                tabs={[
                                    {
                                        title: 'Members',
                                        key: WorkspaceSettingsSettingTabsTypeEnum.Members,
                                        component: <WorkspaceMemberSetting />, // Replace with actual component
                                    },
                                ]}
                                selectedTabValue={WorkspaceSettingsSettingTabsTypeEnum.Members}
                            />
                        </>
                    }
                    fullWidth
                    maxWidth="md"
                />
            )}
        </>
    );
};

export default WorkspaceSetting;
